import { extendTheme } from '@chakra-ui/react';
import { createBreakpoints } from '@chakra-ui/theme-tools';
import bp from 'styles/breakpoints';
import { antique, cofo, fontSizes } from './common/fonts';
import { Button, Input, Select, Modal, Switch, Tag } from './components';
import GlobalThemeStyles from './common/global-styles';
import { colors, layerStyles, shadows, radii, textStyles } from './common';

const breakpoints = createBreakpoints(bp);

const mychoooseTheme = extendTheme({
  radii,
  layerStyles,
  fonts: {
    body: cofo,
    heading: antique,
  },
  breakpoints,
  colors,
  shadows,
  fontSizes,
  textStyles,
  components: {
    Button,
    Input,
    Select,
    Modal,
    Switch,
    Tag,
  },
});

export { mychoooseTheme as theme, GlobalThemeStyles };
